import * as Fetch from '../data/Fetch';

const setAllSitesType = 'SET_ALL_SITES';
const setSiteType = 'SET_SITE';
const setSitesFetchingType = 'SET_SITES_FETCHING';

const initialState = {
    all: null,
    fetching: false,
    site: null
};

export const emptySite = {
    code: "",
    name: ""
};

export const actionCreators = {
    create: (studies,dynaIds) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sitesState = getState().sites;
        if (badState(accountsState, sitesState, true, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Sites/AddNew");
        const site = sitesState.site;
        var studyIds = [];
        var myDynaVisionIds = [];

        if (studies != null &&
            studies.forEach != null) {
            studies.forEach(study => {
                studyIds.push(study.id);
				const dynaRec = dynaIds.find( function (d) { return (d.studyId === study.id) } );
                myDynaVisionIds.push( Math.trunc(dynaRec && dynaRec.dynaId) );
            });
        }

        const body = JSON.stringify({
            code: site.code,
            name: site.name,
            studyIds: studyIds,
			dynaIds: myDynaVisionIds,
        });
        await Fetch.postRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    },

    get: (siteId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sitesState = getState().sites;
        if (badState(accountsState, sitesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Sites/GetById?id=${siteId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setSiteType);
    },

    getAll: () => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sitesState = getState().sites;
        if (badState(accountsState, sitesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl("Sites/GetAll");
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllSitesType);
    },

    getAllByAuthenticatedUserStudy: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sitesState = getState().sites;
        if (badState(accountsState, sitesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Sites/GetAllByAuthenticatedUserStudy?studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllSitesType);
    },

    getAllByStudy: (studyId) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sitesState = getState().sites;
        if (badState(accountsState, sitesState, false, dispatch)) {
            return;
        }

        const url = await Fetch.getUrl(`Sites/GetAllByStudy?studyId=${studyId}`);
        const data = await Fetch.getRequest(url, accountsState.authenticatedToken);
        setResponse(data, dispatch, setAllSitesType);
    },

    set: (data) => async (dispatch) => {
        dispatch({ type: setSiteType, data });
    },

    update: (studies,dynaIds) => async (dispatch, getState) => {
        const accountsState = getState().accounts;
        const sitesState = getState().sites;
        if (badState(accountsState, sitesState, true, dispatch)) {
            return;
        }

        const site = sitesState.site;
        const url = await Fetch.getUrl(`Sites/Update?id=${site.id}`);
        var studyIds = [];
        var myDynaVisionIds = [];

        if (studies != null &&
            studies.forEach != null) {
            studies.forEach(study => {
                studyIds.push(study.id);
				const dynaRec = dynaIds.find( function (d) { return (d.studyId === study.id) } );
                myDynaVisionIds.push( Math.trunc(dynaRec && dynaRec.dynaId) );
            });
        }

        const body = JSON.stringify({
            code: site.code,
            name: site.name,
            studyIds: studyIds,
			dynaIds: myDynaVisionIds,
        });
        await Fetch.putRequest(url, body, accountsState.authenticatedToken);
        setFetching(false, dispatch);
    }
};

function badState(accountsState, sitesState, checkSite, dispatch) {
    if (accountsState == null ||
        sitesState == null ||
        sitesState.fetching) {
        return true;
    }
    if (checkSite &&
        sitesState.site == null) {
        return true;
    }

    setFetching(true, dispatch);
    return false;
}

function setFetching(data, dispatch) {
    dispatch({ type: setSitesFetchingType, data });
}

function setResponse(data, dispatch, type) {
    Fetch.setResponse(data, dispatch, type, setSitesFetchingType);
}

export const reducer = (state, action) => {
    state = state || initialState;

    if (action.type === setAllSitesType) {
        return {
            ...state,
            all: action.data
        };
    }

    if (action.type === setSiteType) {
        return {
            ...state,
            site: action.data
        };
    }

    if (action.type === setSitesFetchingType) {
        return {
            ...state,
            fetching: action.data
        };
    }

    return state;
};



// WEBPACK FOOTER //
// ./src/store/Sites.js